import React, { useEffect, useState } from 'react'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import LeftArrow from '../../icons/left-arrow.svg?react'
import { ComputeFactory } from '../../models/ComputeFactory'
import { RecordFactory } from '../../models/RecordFactory'
import { RecordNotFoundError } from '../../models/errors/RecordNotFoundError'
import { PREMIUM_ID, PREMIUM_LITE_PRICE } from '../../utils/constants'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { PSButton, PSButtonPrimary } from '../app/PSButton'

const viewWillAppear = async (base: PocketComponent) => {
    const subscription = await ComputeFactory.getInstance().fetchPremiumSubscription()
    const result = await RecordFactory.getInstance().fetchPremiumFeatures(base.me)
    let billingFeatures = []
    if (result.ok) {
        billingFeatures = result.value
    }
    else {
        base.logAndDisplayError(result.error)

        return new RecordNotFoundError()
    }

    return { subscription, billingFeatures }
}

const render = ({ base, data }: PocketComponentProps<ComponentData<typeof viewWillAppear>>) => {
    if (data instanceof RecordNotFoundError) {
        throw data
    }

    const user = base.me
    const navigate = usePSNavigate()

    const [offerLite, setOfferLite] = useState(false)

    const activePSSubscription = data.subscription
    const billingFeatures = data.billingFeatures

    useEffect(() => {
        if (!user || !activePSSubscription?.id) return

        const { plan, interval, frequency, amount, source } = activePSSubscription
        const shouldOfferLite = !(
            user.edition?.allowBasicPlan ||
            Number(user.featurecap) > 0 ||
            interval !== 1 ||
            plan?.id !== PREMIUM_ID ||
            frequency !== 'monthly' ||
            !amount ||
            amount <= PREMIUM_LITE_PRICE ||
            !source
        )

        setOfferLite(shouldOfferLite)
    }, [user, activePSSubscription])

    return (
        <div className="supportSettings">
            <div className="header">
                <PSButton className="left" onClick={() => navigate(-1)}>
                    <LeftArrow />
                </PSButton>
                <h1 className="title">Are you sure?</h1>
                <div className="right">
                    <PSButton
                        onClick={() =>
                            navigate(
                                offerLite
                                    ? '/settings/change-plan/cancel/lite'
                                    : '/settings/change-plan/cancel/feedback'
                            )
                        }
                    >
                        Continue cancellation
                    </PSButton>
                    <PSButtonPrimary onClick={() => navigate('/', { replace: true })}>
                        Never mind
                    </PSButtonPrimary>
                </div>
            </div>
            <div className="separator" />
            <p className="details">If you cancel your plan you'll lose out on these benefits.</p>
            {billingFeatures.map(({ id, title, details }) => (
                <div className="supportCard column" key={`billing-feature-${id}`}>
                    <div className="title">{title}</div>
                    <div className="details">{details}</div>
                </div>
            ))}
        </div>
    )
}

export const DowngradeFeaturesPage = usePSComponent(render, viewWillAppear)
